import { render, staticRenderFns } from "./cardInternationalDetail.vue?vue&type=template&id=c8ccfd38&scoped=true&"
import script from "./cardInternationalDetail.vue?vue&type=script&lang=js&"
export * from "./cardInternationalDetail.vue?vue&type=script&lang=js&"
import style0 from "./cardInternationalDetail.vue?vue&type=style&index=0&id=c8ccfd38&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8ccfd38",
  null
  
)

export default component.exports